var Basket = React.createClass({
	
	handleSaveSet: function(e) {
		e.preventDefault();
		
		var name = $(this.refs.name).val();
		
		this.props.onSaveSet( name );
	},
	
	handleCopySet: function(e) {
		e.preventDefault();
		this.props.onCopyCurrentSet();
	},
	
	handleRemove: function(id) {
		var products = [];
		
		for (var i in this.props.set.products) {
			if (this.props.set.products[i].id != id) {
				products.push(this.props.set.products[i]);
			}
		}
		this.props.set.products = products;
		this.props.onUpdateBasket(this.props.set);
	},
	
	handleChangeWeight: function(id, weight) {
		weight = weight;
		
		for (var i in this.props.set.products) {
			if (this.props.set.products[i].id == id && weight >= 0) {
				this.props.set.products[i].weight = weight;
			}
		}
		
		this.props.onUpdateBasket(this.props.set);
	},
	
	_displayNumber: function(num) {
		return Math.round(num * 100) / 100;
	},
	
  render: function() {
  	
  	var products = [],
  		that = this,
  		sum = {
  			weight: 0,
  			energy: 0,
  			protein: 0,
  			phe: 0,
  		},
  		save: null;
  	
  	for (var i in this.props.set.products) {
  		var product = this.props.set.products[i],
  			weight = parseInt(product.weight);
  		
  		if (!weight) {
  			weight = 0;
  		}
  		
  		sum.weight += weight;
  		sum.energy += weight/100 * product._kcal;
  		sum.protein += weight/100 * product._bialko;
  		sum.phe += weight/100 * product._phe;
  		
  		products.push(
  			<BasketRow product={product} onChangeWeight={this.handleChangeWeight} onRemove={this.handleRemove} displayNumber={this._displayNumber} />
  		);
  	}
  	
  	if (this.props.set.id) {
  		save = (
  			<div className="text-center">
  				<button type="submit" className="btn btn-green" onClick={this.handleCopySet}>Skopiuj</button>
  			</div>
  		);
  	} else if (this.props.user.id) {
  		save = (
  			<div className="basket-save-set">
	  			<form className="form-inline" onSubmit={this.handleSaveSet}>
	  				<div className="form-group">
	  					<label>Zapisz zestaw:&nbsp;</label>
	  					<input ref="name" type="text" className="form-control" placeholder="Nazwa zestawu" />
	  				</div>
	  				&nbsp;
	  				<button type="submit" className="btn btn-green">Zapisz</button>
	  			</form>
	  		</div>
  		);
  	}
  	
  	var dailyNeedPercentage = {
  		energy: 100*sum.energy / (this.props.user.energy == 0 ? 1000000 : this.props.user.energy),
  		protein: 100*sum.protein / (this.props.user.protein == 0 ? 1000000 : this.props.user.protein),
  		phe: 100*sum.phe / (this.props.user.phe == 0 ? 1000000 : this.props.user.phe)
  	};
  	
  	
  	
  	return (
  		<div>
  			<div className="content-column-header">
				<div className="column-title">
					<div className={"pull-right" + (dailyNeedPercentage.phe > 100 ? ' color-danger' : '') }>{this._displayNumber(dailyNeedPercentage.phe)}% PHE</div>
					
					{this.props.set.name} 
				</div>
  			</div>
	  		<div className="content-column-content">
				<table className="table table-striped product-table">
		      		<thead>
			      		<tr>
			      			<th>&nbsp;</th>
			      			<th>waga<br /><small>g</small></th>
			      			<th>energia<br /><small>kcal</small></th>
			      			<th>białko<br /><small>g</small></th>
			      			<th>PHE<br /><small>mg</small></th>
			      			<th>usuń</th>
			      		</tr>
			      	</thead>
			      	<tbody>
			      		{products}
			      	</tbody>
			      	<tfoot>
			      		<tr className="basket-row-sum">
			      			<th className="text-right">SUMA:</th>
			      			<th width="1" className="nowrap">
			      				{this._displayNumber(sum.weight)} g
			      			</th>
			      			<th width="1" className="nowrap">
			      				{this._displayNumber(sum.energy)} kcal
			      			</th>
			      			<th width="1" className="nowrap">
			      				{this._displayNumber(sum.protein)} g
			      			</th>
			      			<th width="1" className="nowrap">
			      				{this._displayNumber(sum.phe)} mg
			      			</th>
			      			<th width="1">&nbsp;</th>
			      		</tr>
			      		<tr className="basket-row-daily-need">
			      			<th className="text-right">%<br /><small>dzienny:</small></th>
			      			<th width="1" className="nowrap">&nbsp;</th>
			      			<th width="1" className={"nowrap" + (dailyNeedPercentage.energy > 100 ? ' color-danger' : '') }>
			      				{Math.round(dailyNeedPercentage.energy)}%
			      			</th>
			      			<th width="1" className={"nowrap" + (dailyNeedPercentage.protein > 100 ? ' color-danger' : '') }>
			      				{Math.round(dailyNeedPercentage.protein)}%
			      			</th>
			      			<th width="1" className={"nowrap" + (dailyNeedPercentage.phe > 100 ? ' color-danger' : '') }>
			      				{Math.round(dailyNeedPercentage.phe)}%
			      			</th>
			      			<th width="1" className="nowrap">&nbsp;</th>
			      		</tr>
			      	</tfoot>
		      	</table>
		      	{save}
			</div>
		</div>
    );
  },
});

var BasketRow = React.createClass({
	handleChangeWeight: function(e) {
		var t = $(e.target);
		
		if (t.val() < 100000) {
			this.props.onChangeWeight( this.props.product.id, t.val() );
		}
	},
	
  render: function() {
  	var product = this.props.product,
  		that = this,
  		dn = this.props.displayNumber;
  	
  	return (
	  	<tr key={'basket_product_' + product.id}>
			<td>{product.name}</td>
			<td width="90" className="nowrap text-right">
				<input type="number" maxLength="4" className="form-control input-sm basket-row-input text-center" value={product.weight} onChange={this.handleChangeWeight} />
			</td>
			<td width="80" className="nowrap text-center">{dn(product.weight/100 * product._kcal)}</td>
			<td width="80" className="nowrap text-center">{dn(product.weight/100 * product._bialko)}</td>
			<td width="80" className="nowrap text-center">{dn(product.weight/100 * product._phe)}</td>
			<td width="80" className="nowrap text-center">
				<button className="btn btn-circle btn-icon-delete" onClick={that.props.onRemove.bind(that, product.id) }>&nbsp;</button>
			</td>
		</tr>
    );
  },
});

var CategoryProducts = React.createClass({
	
  render: function() {
  	
  	return (
	  	<div>
			<div className="category-products-p1">Podane wartości na 100g produktu</div>
	      	<ProductTable {...this.props} products={this.props.category.products} />
	    </div>
    );
  },
});

var Column = React.createClass({
	handleChangeColumn: function(e) {
		
		if (!this.props.active) {
			// jeśli kolumna nie była aktywna, to ją pokazujemy
			this.props.onChangeColumn(this.props.column, true);
		} else if ($(e.target).is('.content-column-header') || $(e.target).parents('.content-column-header').length > 0 ) {
			// jeśli kolumna była aktywna, i kliknięto w nagłówek, to chowamy
			this.props.onChangeColumn(this.props.column, !this.props.active);
		}
		
	},
	
	render: function() {
		return (
			<section 
				className={ "content-column " + (this.props.active ? 'active' : 'inactive')} 
				id={this.props.id} 
				onClick={ this.handleChangeColumn }
				>
				{this.props.children}
			</section>
		);
	},
});

var EditMyProduct = React.createClass({
	handleAdd: function() {
		var refs = this.refs,
			parseFormValue = function(key) {
				var elt = $(refs[key]),
					val = elt.val();
				
				elt.val("");
				
				val = val.replace(',', '.');
				val = parseFloat(val);
				
				return val;
			},
			product = {
				id: Math.floor((Math.random() * 100000) + 1),
				name: $(this.refs.name).val(),
				_kcal: parseFormValue('kcal'),
				_bialko: parseFormValue('bialko'),
				_phe: parseFormValue('phe'),
			};
		
		$(this.refs.name).val("");
		this.props.onAddProduct(product);
	},
	
  render: function() {
  	if (!this.props.show) {
  		return null;
  	}
  	
  	return (
		<tr className="add-product-form">
			<td><div className="pos-relative"><input ref="name" type="text" className="form-control add-product-name" placeholder="nazwa produktu" /></div></td>
			<td><input ref="kcal" type="number" className="form-control" placeholder="kcal" /></td>
			<td><input ref="bialko" type="number" className="form-control" placeholder="g" /></td>
			<td><input ref="phe" type="number" className="form-control" placeholder="mg" /></td>
			<td colSpan="2">
				<button onClick={this.handleAdd} className="btn btn-green btn-block">Dodaj</button>
			</td>
		</tr>
    );
  },
});

var Header = React.createClass({
	componentDidMount: function() {
		$('#header-help-modal').modal('show');
	},
	
	getInitialState: function () {
		var initialState = {
				message: null
			}
		return initialState;
	},
	
	handleToggleNav: function(e) {
		e.preventDefault();
		
		this.props.onChangeAction({
			header_active: !this.props.active
		});
	},
	
	handleChange: function(e) {
		var t = $(e.target),
			name = t.attr('name'),
			val = t.val();
			
		this.props.onChangeUserParam(name, val);
	},
	
	handleFullScreen: function() {
		if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement ) {  // current working methods
			if (document.documentElement.requestFullscreen) {
				document.documentElement.requestFullscreen();
			} else if (document.documentElement.msRequestFullscreen) {
				document.documentElement.msRequestFullscreen();
			} else if (document.documentElement.mozRequestFullScreen) {
				document.documentElement.mozRequestFullScreen();
			} else if (document.documentElement.webkitRequestFullscreen) {
				document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
			}
		} else {
			if (document.exitFullscreen) {
				document.exitFullscreen();
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen();
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen();
			} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen();
			}
		}
	},
	
	handleFormSubmit: function(e) {
		this.handleToggleNav(e);
		
		window.navigator.notification.alert('Pamiętaj, aby w swoim dziennym zapotrzebowaniu uwzględnić przyjmowany preparat PKU', function() {}, 'Uwaga!', 'OK');
	},
	
	handleChangeAction: function(params) {
		params.header_active = false;
		this.props.onChangeAction(params);
	},
	
	handleAuthenticate: function(e) {
		e.preventDefault();
		
		var that = this,
			params = {
				action: 'auth', 
				login: $(this.refs.login).val(),
				password: $(this.refs.password).val(),
			};
		
		$.getJSON(window.DOMAIN + '/user.php', params)
			.done(function(response) {
				if (response.status != 'OK') {
					that.state.message = response.message;
					that.setState(that.state);
				} else {
					that.state.message = null;
					that.setState(that.state);
					that.props.onLogin(response.access_token);
				}
			})
			.fail(function() {
				that.state.message = 'Wystąpiły problemy z połączeniem, spróbuj ponownie później';
				that.setState(this.state);
			});
		
	},
	
  render: function() {
  	var auth = null;
  	
  	if (this.props.user.id) {
  		auth = null;
  	} else {
  		auth = (
  			<form onSubmit={this.handleAuthenticate}>
	      		<ul className="list-inline">
	      			<li className="header-user-parameters-p1">Masz już konto w PKUconnect?</li>
	      			{ this.state.message ? (<li className="header-user-parameters-p1">{this.state.message}</li>) : null }
	      			<li>
	      				<div className="form-group">
	      					<label>e-mail</label>
	      					<input ref="login" type="text" className="form-control" name="login" />
	      				</div>
					</li>
	      			<li>
	      				<div className="form-group">
	      					<label>hasło</label>
	      					<input ref="password" type="password" className="form-control" name="password" autoComplete="off" />
	      				</div>
					</li>
					<li>
						<div className="form-group">
	      					<label className="label-empty">&nbsp;</label>
	      					<div className="input-group">
								<button type="submit" className="btn btn-default btn-green">Zaloguj</button>
								<a target="_blank" href="http://pkuconnect.pl" className="btn btn-default btn-fiolet">Zarejestruj</a>
							</div>
						</div>
					</li>
	      		</ul>
	      	</form>
  		);
  	}
  	
  	return (
      <section id="header" className={this.props.active ? 'active' : ''}>
      	<a href="#" className="header-logo" onClick={() => this.handleChangeAction({action: "INDEX"}) }>&nbsp;</a>
      	<div className="header-icons">
      		<span className="header-nav">
	      		{
	      			this.props.user.id 
	      			? (<a href="#" className="header-icon header-icon-wyloguj" onClick={this.props.onLogout}>wyloguj</a>)
	      			: null
	      		}
	      		<a href="#header-info-modal" data-toggle="modal" className="header-icon header-icon-regulamin">informacje</a>
	      		<a href="#header-help-modal" data-toggle="modal" className="header-icon header-icon-help">pomoc</a>
	      	</span>
      		<a href="#" className="show-mobile header-icon header-icon-bootstrap" onClick={this.handleToggleNav}  id="header-nav-hamburger">
      			<span className="glyphicon glyphicon-align-justify" /><br />
      			menu
      		</a>
      	</div>
      	<div className="header-authenticate">
      		{auth}
      	</div>
      	<div className="header-user-parameters">
      		<form onSubmit={this.handleFormSubmit}>
	      		<ul className="list-inline">
	      			<li className="header-user-parameters-p1">
	      				Moje dzienne zapotrzebowanie:
	      				<br /><small>(zgodnie z zalecenami lekarza)</small>
	      			</li>
	      			<li>
	      				<div className="form-group">
	      					<label>białko</label>
	      					<div className="input-group">
	      						<input type="number" className="form-control" name="protein" value={this.props.user.protein} onChange={this.handleChange} />
	      						<div className="input-group-addon">g</div>
	      					</div>
	      				</div>
					</li>
	      			<li>
	      				<div className="form-group">
	      					<label>energia</label>
	      					<div className="input-group">
	      						<input type="number" className="form-control" name="energy" value={this.props.user.energy} onChange={this.handleChange} />
	      						<div className="input-group-addon">kcal</div>
	      					</div>
	      				</div>
					</li>
	      			<li>
	      				<div className="form-group">
	      					<label>PHE</label>
	      					<div className="input-group">
	      						<input type="number" className="form-control" name="phe" value={this.props.user.phe} onChange={this.handleChange} />
	      						<div className="input-group-addon">mg</div>
	      					</div>
	      				</div>
					</li>
					<li>
						<div className="form-group">
	      					<label>&nbsp;</label>
	      					<div className="input-group">
								<button type="submit" className="btn btn-default btn-green">ZAPISZ</button>
							</div>
						</div>
					</li>
	      		</ul>
	      	</form>
      	</div>
      	<div className="modal fade" id="header-info-modal" tabindex="-1" role="dialog">
      		<div className="modal-dialog" role="document">
      			<div className="modal-content">
      				<div className="modal-header">
      					<button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      					<h4 className="modal-title" id="myModalLabel">Informacje</h4>
      				</div>
      				<div className="">
      					<div className="fiolet-link-list">
							<a href="http://pkuconnect.pl/licznik/rate.php">ZOSTAW RECENZJĘ PROGRAMU</a>
							<a href="mailto:?subject=Sprawdź PKULicznik&body=Cześć, polecam Ci nowy licznik PHE: http://pkuconnect.pl/licznik">ZAREKOMENDUJ NAS PRZYJACIELOWI</a>
							<a href="mailto:redakcja@pkuconnect.pl">NAPISZ DO NAS</a>
						</div>
						<p className="header-info-modal-p">Aplikacja PKULicznik działa w połączeniu<br />z serwisem PKUconnect.pl</p>
      					<div className="fiolet-link-list">
							<a href="http://pkuconnect.pl/">Przejdź do serwisu PKUconnect</a>
						</div>
						<div className="fiolet-link-list">
							<a href="http://pkuconnect.pl/polityka-prywatnosci/">Regulamin i polityka prywatności PKUconnect</a>
						</div>
      				</div>
      				<div className="modal-footer">
        				<button type="button" className="btn btn-default" data-dismiss="modal">Zamknij</button>
      				</div>
      			</div>
      		</div>
      	</div>
      	<div className="modal fade" id="header-help-modal" tabindex="-1" role="dialog">
      		<div className="modal-dialog modal-lg" role="document">
      			<div className="modal-content">
      				<div className="pos-relative" >
      					<button type="button" className="close help-popup-close"  data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      				
      					<div className="visible-md-block visible-lg-block"><img className="img-responsive" src="img/instrukcja.jpg" alt="" /></div>
      					<div className="visible-sm-block visible-xs-block"><img className="img-responsive" src="img-mobile/instrukcja.jpg" alt="" /></div>
      					
      					<div className="fiolet-link-list">
							<a target="_blank" href="https://youtu.be/B44jwAkab60">Zobacz jak korzystać z aplikacji</a>
						</div>
      				</div>
      				<div className="modal-footer">
      					<button type="button" className="btn btn-default" data-dismiss="modal">Zamknij</button>
      				</div>
      			</div>
      		</div>
      	</div>
      </section>
    );
  },
});

var LeftColumn = React.createClass({
	componentDidMount: function() {
		$(window).resize(function() {
			if ($(window).width() > 1160) {
				$('.antiscroll-wrap').antiscroll();
			} else {
				$('.antiscroll-wrap').each(function() {
					var scroll = $(this).data('antiscroll');
					if (scroll) {
						scroll.destroy();
						$(this).data('antiscroll', null);
						$('.antiscroll-inner', this).css('width', '');
						$('.antiscroll-inner', this).css('height', '');
					}
				});
			}
		});
	},
	
	componentDidUpdate: function() {
		$(window).resize();
	},
	
  handleSearch: function(e) {
  	e.preventDefault();
  	var input = $(this.refs.search),
  		params = {search: input.val()};
  	
  	if (e.nativeEvent.type == 'submit') {
  		params.action = 'SEARCH';
  	} else {
  		params.action = 'INDEX';
  	}
  	
  	this.props.onChangeAction(params);
  },
  
  handleChangeAction: function(category) {
  	this.props.onChangeAction({action: 'PRODUCT_CATEGORY', category: category, set: null});
  },
  
  handleToggleCategory: function(category) {
  	this.props.onToggleCategory(category)
  },
  
  render: function() {
  	var categories = [],
  		that = this,
  		ca = this.handleChangeAction;
  	
  	for (var i in this.props.categories) {
  		var category = this.props.categories[i],
  			subcategories = [];
  		
  		for (var j in category.subcategories) {
  			var subcategory = category.subcategories[j];
  			
	  		subcategories.push(
	  			<a key={"subcategory_" + subcategory.id} href="#" 
	  				onClick={ ca.bind(that, subcategory) } 
	  				className={ (this.props.action == "PRODUCT_CATEGORY" && this.props.category.id == subcategory.id ? "active": "") }
	  				>
	  				{subcategory.name}
	  			</a>
	  		);
  		}
  		
  		categories.push(
	      	<div className={"left-column-fiolet-list " + (category.open ? 'open' : 'closed') } key={"category_" + category.id}>
	      		<div className="left-column-fiolet-list-header" onClick={ this.handleToggleCategory.bind(that, category)  }>
	      			<span className="anchor" />
	      			{category.name}
	      		</div>
	      		<div className="left-column-fiolet-list-subcategories">
	      			{subcategories}
	      		</div>
	      	</div>
  		);
  		
  	}
	return (
		<div className="antiscroll-wrap">
			<div className="antiscroll-inner">
				<div className="content-column-header">
					<div className="column-title">KATEGORIE</div>
				</div>
				<div className="content-column-content">
			      	<form role="search" onSubmit={this.handleSearch}>
						<div className="input-group">
							<input ref="search" type="text" className="form-control" placeholder="Szukaj" name="q" onChange={this.handleSearch} />
							<div className="input-group-btn">
								<button className="btn btn-fiolet" type="submit"><i className="glyphicon glyphicon-search"></i></button>
							</div>
						</div>
					</form>
					<br />
		      		<div className="left-column-green-list">
		      			<a href="#" onClick={() => this.props.onChangeAction({action: 'MY_SETS'})} className={ "icon-my-sets " + (this.props.action == "MY_SETS" ? "active": "") }>moje zestawy</a>
		      			<a href="#" onClick={() => this.props.onChangeAction({action: 'MY_PRODUCTS'})} className={ "icon-my-products " + (this.props.action == "MY_PRODUCTS" ? "active": "") }>moje produkty</a>
		      			<a href="#" onClick={() => this.props.onChangeAction({action: 'FAVOURITE_PRODUCTS'})} className={ "icon-my-favourite-products " + (this.props.action == "FAVOURITE_PRODUCTS" ? "active": "") }>ulubione produkty</a>
			      	</div>
			      	{categories}
				</div>
			</div>
		</div>
	);
  },
});

var ProductRow = React.createClass({
	handleAddToBasket: function(e) {
		e.preventDefault();
		e.stopPropagation();
		
		this.props.onAddToBasket(this.props.product);
	},
	
	handleFavourite: function(e) {
		e.preventDefault();
		this.props.onFavourite(this.props.product.id);
	},
	
	handleRemove: function(e) {
		e.preventDefault();
		this.props.onRemoveMyProduct(this.props.product.id);
	},
	
  render: function() {
  	var product = this.props.product;
  	
  	return (
	  	<tr key={'product_' + product.id}>
			<td>{product.name}</td>
			<td className="text-center">{product._kcal}</td>
			<td className="text-center">{product._bialko}</td>
			<td className={"text-center " + (product._phe > 150 ? 'product-danger' : '')} >{product._phe}</td>
			<td className="text-center">
				{
					this.props.editable
					? <button className="btn btn-circle btn-icon-delete" onClick={this.handleRemove}>&nbsp;</button>
					: <button className={"product-favourite " + (this.props.user.favourites[product.id] ? " active" : "") } onClick={this.handleFavourite} />
				}
				
			</td>
			<td className="text-center"><button className="btn btn-circle btn-icon-add" onClick={this.handleAddToBasket }>&nbsp;</button></td>
		</tr>
    );
  },
});

var ProductTable = React.createClass({
	getInitialState: function () {
		var initialState = {
			limit: 15
		};
		return initialState;
		
	},
	
	handleShowMore: function() {
		this.state.limit += 15;
		this.setState(this.state);
	},
	
  render: function() {
  	
  	var products = [],
  		that = this,
  		add = null;
  	
  	for (var i in this.props.products) {
  		if (i < this.state.limit) {
  			var product = this.props.products[i];
  		
	  		products.push(
	  			<ProductRow {...this.props} editable={this.props.showAdd} key={"product_" + product.id} product={product} />
	  		);
	  	}
  	}
  	
  	return (
	  	<table className="table table-striped product-table">
	      	<thead>
	      		<EditMyProduct show={this.props.showAdd} onAddProduct={this.props.onAddMyProduct} />
      			<tr>
	      			<th>&nbsp;</th>
	      			<th>energia<br /><small>kcal</small></th>
	      			<th>białko<br /><small>g</small></th>
	      			<th>PHE<br /><small>mg</small></th>
	      			<th className="text-center"><small>{this.props.showAdd ? 'usuń' : 'ulubione'}</small></th>
	      			<th className="nowrap"><small>do<br />zestawu</small></th>
	      		</tr>
	      	</thead>
	      	<tbody>
	      		{products}
	      		
	      		{ (() => {
	      			if (this.state.limit < this.props.products.length) {
	      				return (<tr><td colSpan="6" align="center"><button className="btn btn-green" onClick={this.handleShowMore}>pokaż więcej</button></td></tr>);
	      			}
	      		})()}
	      	</tbody>
      	</table>
    );
  },
});

var FavouriteProductsAction = React.createClass({
  render: function() {
  	var products = [],
  		fav = this.props.user.favourites;
  	
  	
  	for (var i in this.props.categories) {
  		for (var j in this.props.categories[i].subcategories) {
  			var c = this.props.categories[i].subcategories[j];
  			for (var k in c.products) {
  				if (fav[ c.products[k].id ]) {
  					products.push(c.products[k]);
  				}
  			}
  		}
  	}
  	
  	// sortowanie listy
	var sortable = [];
	for (var i in products) {
		sortable.push(products[i]);
	}
	
	sortable.sort(
	    function(a, b) {
	        return a.name.localeCompare(b.name);
	    }
	);

	// render listy
  	return (
		<div className="content-column-no-panel" id="my-favourites">
			<div className="content-column-header">
				<div className="column-title">Ulubione produkty</div>
			</div>
			<div className="content-column-content">
		      	<ProductTable products={sortable} onAddToBasket={this.props.onAddToBasket} onFavourite={this.props.onFavourite} user={this.props.user} />
		    </div>
  		</div>
    );
  },
});

var HelpAction = React.createClass({
  render: function() {
  	return (
		<div>
  			<div className="content-column-header">
				<div className="column-title">PKUConnect</div>
  			</div>
	  		<div className="content-column-content text-center">
				<h3>
					<br /><br />
					Wybierz kategorię produktów,<br /> 
					aby wyświetlić produkty<br /> 
					i dodać je do zestawu
				</h3>
			</div>
		</div>
    );
  },
});

var MyProductsAction = React.createClass({
  render: function() {
  	// sortowanie listy
	var sortable = [];
	for (var i in this.props.user.products) {
		sortable.push(this.props.user.products[i]);
	}
	
	sortable.sort(
	    function(a, b) {
	        return a.name.localeCompare(b.name);
	    }
	);

	// render listy
  	return (
		<div className="content-column-no-panel" id="my-products">
			<div className="content-column-header">
				<div className="column-title">Moje produkty</div>
			</div>
			<div className="content-column-content">
		      	<ProductTable {...this.props} products={sortable} showAdd="1" />
		    </div>
  		</div>
    );
  },
});

var MySetsAction = React.createClass({
	handleChangeSet: function(set, e) {
		e.preventDefault();
		e.stopPropagation();
		
		this.props.onChangeAction({set: set});
	},
	
	handleCreateSet: function(e) {
		e.preventDefault();
		e.stopPropagation();
		
		this.props.onChangeAction({set: -1});
	},
	
	handleRemoveSet: function(id, e) {
		e.preventDefault();
		e.stopPropagation();
		
		this.props.onRemoveSet(id);
	},
	
  render: function() {
  	// sortowanie listy
	var sortable = [];
	for (var i in this.props.sets) {
		sortable.push(this.props.sets[i]);
	}
	
	sortable.sort(
	    function(a, b) {
	        return a.name.localeCompare(b.name);
	    }
	);

	// render listy
  	var sets = [],
  		that = this,
  		cs = this.handleChangeSet;
  	
  	for (var i in sortable) {
  		var set = sortable[i];
  		
  		if (i >= 0) {
	  		sets.push(
	  			<a key={"set_" + set.id} href="#" onClick={ cs.bind(that, set.id) } className={(set.id == this.props.set ? 'active' : '') }>
	  				<button className="btn btn-circle btn-icon-delete pull-right" onClick={that.handleRemoveSet.bind(that, set.id) }>&nbsp;</button>
	  				
	  				{set.name}
	  			</a>
	  		);
	  	}
  	}
  	
  	return (
		<div id="my-sets">
			<div className="content-column-header">
				<div className="column-title">Moje zestawy</div>
			</div>
			<div className="content-column-content">
				<div className="text-center">
					<br />
					<button className="btn-add btn btn-green" onClick={this.handleCreateSet}>Utwórz nowy zestaw</button>
					<br />
					&nbsp;
				</div>
				<div className="my-sets-list">
					{sets}
				</div>
			</div>
  		</div>
    );
  },
});

var ProductCategoryAction = React.createClass({
  render: function() {
  	return (
		<div className="content-column-no-panel">
			<div className="content-column-header">
				<div className="column-title">{this.props.category.name}</div>
			</div>
			<div className="content-column-content">
	  			<CategoryProducts {...this.props} />
	  		</div>
  		</div>
    );
  },
});

var SearchAction = React.createClass({
  render: function() {
  	var products = [],
  		query = this.props.query.toLocaleLowerCase();
  	
  	for (var i in this.props.categories) {
  		for (var j in this.props.categories[i].subcategories) {
  			var c = this.props.categories[i].subcategories[j];
  			
  			for (var k in c.products) {
  				if (products.length < 75) {
  					if (c.products[k].name.toLocaleLowerCase().indexOf(query) != -1) {
  						products.push(c.products[k]);
  					}
  				}
  			}
  		}
  	}
  	return (
		<div id="search-results">
			<div className="content-column-header">
				<div className="column-title">Wyszukiwanie: {this.props.query}</div>
			</div>
			<div className="content-column-content">
	  			<div className="panel-body text-center">Podane wartości na 100g produktu</div>
	      		<ProductTable {...this.props} products={products} />
	  		</div>
  		</div>
    );
  },
});

if (!window.navigator.notification) {
	window.navigator.notification = {
		alert: function(a) {
			alert(a);
		}
	};
}

var PkuLicznikApp = React.createClass({
	_answered: {},
	
	routes: {
		INDEX: 'INDEX',
		SEARCH: 'SEARCH',
		MY_PRODUCTS: 'MY_PRODUCTS',
		MY_SETS: 'MY_SETS',
		FAVOURITE_PRODUCTS: 'FAVOURITE_PRODUCTS',
		PRODUCT_CATEGORY: 'PRODUCT_CATEGORY'
	},
	columns: {
		LEFT: 'LEFT',
		CENTER: 'CENTER',
		RIGHT: 'RIGHT'
	},
	
	_reloadUserData: function() {
		if (this.state.access_token) {
			var that = this;
			
			$.getJSON(window.DOMAIN + '/user.php', {action: 'get', access_token: this.state.access_token })
				.done(function(response) {
					if (response.status == 'ERROR') {
						that.handleLogout();
					} else if (response.settings) {
						if (window.SAVE_LOCAL) {
							var storage = window.localStorage;
							storage.setItem('settings', JSON.stringify(response.settings));
						}
						
						that.state.user = response.settings;
						that.setState(that.state);
					}
				});
		}
	},
	
	_saveUserData: function() {
		
		if (window.SAVE_LOCAL) {
			var storage = window.localStorage;
			storage.setItem('settings', JSON.stringify(this.state.user));
		}
		
		if (this.state.access_token) {
			var params = {
				action: 'save', 
				access_token: this.state.access_token,
				settings: this.state.user
			};
			
			$.post(window.DOMAIN + '/user.php', params);
		}
		
	},
	
	getInitialState: function () {
		var initialState = {
				action: this.routes.INDEX,
				active_column: {},
				categories: {},
				category: null,
				search: '',
				access_token: null,
				header_active: true,
				user: {
					id: null,
					protein: 0, // 45,
					energy: 0, // 2200,
					phe: 0, // 300,
					favourites: {},
					products: [],
					sets: {},
				},
				set: null,
			};
		
		initialState.active_column[this.columns.LEFT] = true;
		initialState.active_column[this.columns.CENTER] = false;
		initialState.active_column[this.columns.RIGHT] = false;
		
		if (window.SAVE_LOCAL) {
			var storage = window.localStorage;
			if (storage.getItem('categories')) {
				initialState.categories = jQuery.parseJSON(storage.getItem('categories'));
			}
			
			if (storage.getItem('access_token')) {
				initialState.access_token = storage.getItem('access_token');
			}
			
			if (storage.getItem('settings')) {
				try {
					var u = jQuery.parseJSON(storage.getItem('settings'));
					// console.log(u);
					jQuery.extend(initialState.user, u);
				} catch (err) {} 
			}
		}
		
		return initialState;
	},
	
	handleLogin: function(access_token) {
		if (window.SAVE_LOCAL) {
			var storage = window.localStorage;
			storage.setItem('access_token', access_token);
		}
		
		this.state.access_token = access_token;
		this.setState(this.state);
		
		this._reloadUserData();
	},
	handleLogout: function() {
		this.state.access_token = null;
		this.state.user.id = null;
		this.state.user.favourites = {};
		this.state.user.products = [];
		this.state.user.sets = {};
		
		this.setState(this.state);
		
		if (window.SAVE_LOCAL) {
			var storage = window.localStorage;
			storage.removeItem('access_token');
		}
		this._saveUserData();
	},
	
	handleCopyCurrentSet() {
		var id = -1,
			currentSet = this.getCurrentSet(),
			set = {};
		
		// set.id = id; // nowy zestaw bez ID
		set.name = currentSet.name + ' (kopia)';
		set.products = [];
		
		for (var i in currentSet.products) {
			set.products.push( jQuery.extend(true, {}, currentSet.products[i]) );
		}
		
		this.state.set = -1;
		this.state.user.sets[id] = set;
		
		this.setState(this.state);
	},
	
	handleSaveSet(name) {
		var id = Math.floor((Math.random() * 100000) + 1),
			set = this.getCurrentSet();
			
		set.id = id;
		set.name = name;
		
		this.state.set = id;
		this.state.user.sets[id] = set;
		delete this.state.user.sets[-1];
		
		this.setState(this.state);
		this._saveUserData();
	},
	
	handleRemoveSet(id) {
		delete this.state.user.sets[id];
		this.state.set = null;
		this.setState(this.state);
		this._saveUserData();
	},
	
	handleFavourite(productId) {
		if (this.state.user.favourites[productId]) {
			this.state.user.favourites[productId] = false;
			delete this.state.user.favourites[productId];
		} else {
			this.state.user.favourites[productId] = true;
		}
		this.setState(this.state);
		this._saveUserData();
	},
	
	handleChangeUserParam: function(param, val) {
		this.state.user[param] = val;
		this.setState(this.state);
		this._saveUserData();
	},
	
	handleToggleCategory: function(category) {
		category.open = !category.open;
		this.setState(this.state);
	},
	
	getCurrentSet: function() {
		if (!this.state.set || !this.state.user.sets[this.state.set]) {
			this.state.set = -1;
			this.state.user.sets[this.state.set] = {
				name: "Nowy zestaw",
				products: []
			};
			this.setState(this.state);
		}
		
		if (!this.state.user.sets[this.state.set].products) {
			this.state.user.sets[this.state.set].products = [];
			this.setState(this.state);
		}
		
		return this.state.user.sets[this.state.set];
	},
	
	handleAddToBasket: function(product) {
		var basket = this.getCurrentSet();
		
		for (var i in basket.products) {
			if (basket.products[i].id == product.id) {
				return;
			}
		}
		
		product.weight = 100;
		
		basket.products.push(product);
		this.setState(this.state);
		this._saveUserData();
		
		this.handleChangeColumn(this.columns.RIGHT, true);
	},
	
	handleUpdateBasket: function(newBasket) {
		this.state.user.sets[this.state.set] = newBasket;
		this.setState(this.state);
		this._saveUserData();
	},
	
	handleRemoveMyProduct: function(id) {
		var myProducts = [],
			p = null;
		
		for(var i in this.state.user.products) {
			p = this.state.user.products[i];
			if (p.id != id) {
				myProducts.push(p);
			}
		}
		
		this.state.user.products = myProducts;
		this.setState(this.state);
		this._saveUserData();
	},
	
	handleAddMyProduct: function(product) {
		this.state.user.products.push(product);
		this.setState(this.state);
		this._saveUserData();
	},
	
	componentDidMount: function () {
		if (this.state.access_token) {
			this._reloadUserData();
		}
		
		$.getJSON(window.DOMAIN + '/categories.php', function(response) {
			this.state.categories = response;
			this.setState(this.state);
			
			if (window.SAVE_LOCAL) {
				var storage = window.localStorage;
				storage.setItem('categories', JSON.stringify(response));
			}
		}.bind(this));
		
		$('head').append('<style id="addedCSS" type="text/css" />');
		$(window).resize(function(){
			if ($(window).width() > 1160) {
				$('#addedCSS').text('');
			} else if ($(window).width() > 420) {
				$('#addedCSS').text('.content-column-content {max-height:' + ($('.content-columns').innerHeight()-40) + 'px;}');
			} else {
				$('#addedCSS').text('#left-column .content-column-content,#center-column .content-column-content {max-height:' + ($('.content-columns').innerHeight()-40) + 'px;}');
			}
			
			var maxHeight = Math.max($('#left-column .content-column-content').innerHeight(), $('#center-column .content-column-content').innerHeight());
			$('#addedCSS').append('@media (min-width: 420px) AND (max-width:1160px) { #center-column .content-column-content, #right-column .content-column-content {min-height:' + (maxHeight) + 'px;} }');
			$('#addedCSS').append('@media (max-width: 420px) { #center-column .content-column-content {min-height:' + (maxHeight) + 'px;} }');
		}).resize();
	},

	handleClickApp: function(e) {
		if (this.state.active_column[this.columns.RIGHT]) {
			// prawa kolumna jest włączona
			
			var t = $(e.target);
			
			if (!t.is('#right-column') && t.parents('#right-column').length == 0) {
				// klik poza prawą kolumnę, więc ją zwijamy
				e.preventDefault();
				this.handleChangeColumn(this.columns.RIGHT, false);
			}
		}
		
		if (this.state.header_active) {
			// nagłówek włączony
			
			var t = $(e.target);
			
			if (!t.is('#header') && t.parents('#header').length == 0) {
				// klik poza header, więc go zwijamy
				e.preventDefault();
				
				this.state.header_active = false;
				this.setState(this.state);
			}
		} 
	},

	handleChangeAction: function(params) {
		if (!this.state.access_token) {
			if (params.action == this.routes.MY_PRODUCTS
				|| params.action == this.routes.MY_SETS
				|| params.action == this.routes.FAVOURITE_PRODUCTS) {
					
				window.navigator.notification.alert('Aby korzystać z tej funkcji musisz się zalogować', function() {}, 'Uwaga!', 'OK');
				return;
			}
		}
		
		// $('body').removeClass('start');
		
		if (params.action) {
			this.state.action = params.action;
		}
		if (params.category) {
			this.state.category = params.category;
		}
		
		if (params.header_active !== undefined) { // zwinięcie lub rozwinięcie menu górnego
			this.state.header_active = params.header_active;
		} else if (params.action == this.routes.INDEX) {
			this.handleChangeColumn(this.columns.CENTER, false);
		} else {
			this.handleChangeColumn(this.columns.CENTER, true);
		}
		
		if (params.set || params.set == -1) {
			this.state.set = params.set;
			this.state.active_column[this.columns.RIGHT] = true;
		}
		
		if (params.search) {
			this.state.search = params.search;
			this.state.action = this.routes.SEARCH;
		}
		
		this.setState(this.state);
	},
	
	handleChangeColumn: function(column, show) {
		if (column == this.columns.LEFT) {
			this.state.active_column[this.columns.CENTER] = false;
			this.state.active_column[this.columns.RIGHT] = false;
			show = true;
		} else if (column == this.columns.CENTER) {
			this.state.active_column[this.columns.RIGHT] = false;
		}
		
		this.state.active_column[column] = show;
		this.setState(this.state);
		
		// console.log('cc ', column, show);
		setTimeout(function() {$(window).resize();}, 100);
		setTimeout(function() {$(window).resize();}, 1500);
	},

	render: function () {
		var out = null;

		switch (this.state.action) {
			case this.routes.INDEX: 
				out = (<HelpAction /> ); break;
				
			case this.routes.SEARCH: 
				out = (<SearchAction 
							user={this.state.user}
							categories={this.state.categories} 
							query={this.state.search} 
							onChangeAction={this.handleChangeAction} 
							onAddToBasket={this.handleAddToBasket}
							onFavourite={this.handleFavourite} />); break;
				
			case this.routes.MY_PRODUCTS: 
				out = (<MyProductsAction 
							user={this.state.user}
							onAddToBasket={this.handleAddToBasket} 
							onUpdateBasket={this.handleUpdateBasket}
							onAddMyProduct={this.handleAddMyProduct}
							onRemoveMyProduct={this.handleRemoveMyProduct}
							onFavourite={this.handleFavourite}  />); break;
				
			case this.routes.MY_SETS: 
				out = (<MySetsAction 
							sets={this.state.user.sets} 
							set={this.state.set} 
							onChangeAction={this.handleChangeAction}
							onRemoveSet={this.handleRemoveSet} />); break;
				
			case this.routes.FAVOURITE_PRODUCTS: 
				out = (<FavouriteProductsAction  
							basket={this.state.basket} 
							user={this.state.user}
							categories={this.state.categories}
							onAddToBasket={this.handleAddToBasket} 
							onUpdateBasket={this.handleUpdateBasket}
							onFavourite={this.handleFavourite} />); break;
				
			case this.routes.PRODUCT_CATEGORY: 
				out = (<ProductCategoryAction 
							category={this.state.category} 
							user={this.state.user}
							onAddToBasket={this.handleAddToBasket} 
							onFavourite={this.handleFavourite} />); break;
				
			default:
				out = (
					<div>
						<header id="header" className="text-center">
							<h1>Wystąpił błąd!</h1>
						</header>
					</div>
				);
		}
		
		var contentClasses = 'action-' + this.state.action 
			+ ' column-center-' + (this.state.active_column[this.columns.CENTER] ? 'active' : 'inactive')
			+ ' column-right-' + (this.state.active_column[this.columns.RIGHT] ? 'active' : 'inactive')
			+ ' header-' + (this.state.header_active ? 'active' : 'inactive')
		
		return (
			<div id="pkulicznik-app-content" onClick={this.handleClickApp}>
				<Header 
					user={this.state.user} 
					active={this.state.header_active}
					onLogin={this.handleLogin}
					onLogout={this.handleLogout}
					onChangeUserParam={this.handleChangeUserParam} 
					onChangeAction={this.handleChangeAction} />
				<div id="content" className={ contentClasses }>
					<div className="content-columns">
						<Column onChangeColumn={this.handleChangeColumn} active={this.state.active_column[this.columns.LEFT]} id="left-column" column={this.columns.LEFT}>
							<LeftColumn  
								action={this.state.action} 
								category={this.state.category}
								categories={this.state.categories} 
								onChangeAction={this.handleChangeAction} 
								onToggleCategory={this.handleToggleCategory} />
							<div className="left-column-help left-column-help-1">
								Wyszukaj produkt<br />
								wpisując nazwę lub<br />
								wybierz kategorię,<br />
								aby wyświetlić<br /> 
								produkty i dodać je<br />
								do zestawu
							</div>
						</Column>
						
						<Column onChangeColumn={this.handleChangeColumn} active={this.state.active_column[this.columns.CENTER]} id="center-column" column={this.columns.CENTER}>
							{out}
						</Column>
						
						<Column onChangeColumn={this.handleChangeColumn} active={this.state.active_column[this.columns.RIGHT]} id="right-column" column={this.columns.RIGHT}>
							<Basket 
								set={ this.getCurrentSet() }  
								user={this.state.user} 
								onUpdateBasket={this.handleUpdateBasket}
								onChangeAction={this.handleChangeAction}
								onSaveSet={this.handleSaveSet}
								onCopyCurrentSet={this.handleCopyCurrentSet} />
						</Column>
					</div>
				</div>
			</div>
		);
	}
});
				
ReactDOM.render(
	<PkuLicznikApp />,
	document.getElementById('pkulicznik-app')
);
